angular
    .module('festzelt-os.components')
    .filter('typeof', typeOfFilter);

function typeOfFilter() {
    return function (obj) {
        return typeof obj
    };
}



// WEBPACK FOOTER //
// ./src/app/components/filters/typeof.js